import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { EventFormPresentation } from './event-form-presentation';
import { EventFormVM } from './event-form.viewmodel';

interface IProps {
    accountId: number;
    eventId: number;
    saveCompletedCallback: (eventId?: number) => void;
    deleteCompletedCallback?: () => void;
}

const EventFormContainer = withViewModel(EventFormPresentation, async (props: IProps) => {

    const { accountId, eventId, saveCompletedCallback, deleteCompletedCallback } = props;
    const eventFormVM = new EventFormVM(
        accountId,
        eventId,
        saveCompletedCallback,
        deleteCompletedCallback,
    );

    await eventFormVM.initEventInfo();
    return eventFormVM;
}, props => [props.accountId, props.eventId]);


export { EventFormContainer as EventForm };
